<template>
  <div class="bind">
    <div
      class="alert_bg2"
      v-if="$store.state.bind_list && $store.state.bind_list.length <= 0"
    ></div>
    <div class="alert_bg3"></div>
    <div class="bind_wrap" v-if="type == 'bind'">
      <div class="close_btn" @click="onCancelClick"></div>
      <div class="bind_title">发现新设备</div>
      <div class="bind_icon"></div>
      <div class="bind_name">{{ name }}</div>
      <div class="bind_btns">
        <div class="bind_cancel_btn" @click="onCancelClick">取消</div>
        <div class="bind_sure_btn" @click="onSureClick">立即绑定</div>
      </div>
    </div>
    <div class="success_wrap" v-if="type == 'success'">
      <div class="close_btn" @click="onCancelClick"></div>
      <div class="success_title">绑定成功</div>
      <div class="success_icon"></div>
      <div class="success_name">{{ name }}</div>
      <div class="bind_btns">
        <div class="bind_sure_btn" @click="onRefresh">确定({{ second }}s)</div>
      </div>
    </div>
    <div class="failed_wrap" v-if="type == 'failed'">
      <div class="close_btn" @click="onCancelClick"></div>
      <div class="failed_title">绑定失败</div>
      <div class="failed_tips">{{ failed_tips }}</div>
      <div class="failed_help">扫码添加微信客服获取帮助</div>
      <div class="failed_qrcode"></div>
      <div class="failed_sure_btn" @click="onCancelClick">确定</div>
    </div>
    <Tip v-if="tip" :tip="tip"></Tip>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import Tip from "@/components/Tip.vue";
export default {
  components: {
    Tip,
  },
  data: function () {
    return {
      tip: "",
      second: 3,
    };
  },
  props: ["name", "type", "failed_tips"],
  methods: {
    onRefresh: function () {
      window.location.reload();
    },
    onCancelClick: function () {
      this.$emit("onCancelClick");
    },
    onSureClick: function () {
      this.$emit("onSureClick");
    },
    copyClick: function () {
      let _that = this;
      let clipboard = new Clipboard(".copy-class");
      clipboard.on("success", (e) => {
        clipboard.destroy();
        _that.tip = "复制成功";
        setTimeout(function () {
          _that.tip = "";
        }, 1500);
      });
      clipboard.on("error", (e) => {
        clipboard.destroy();
        _that.tip = "复制失败";

        setTimeout(function () {
          _that.tip = "";
        }, 1500);
      });
    },
  },
  mounted: function () {
    let _that = this;
    setInterval(function () {
      if (_that.second > 0) {
        _that.second--;
      }
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
.alert_bg2 {
  width: 960px;
  height: 555px;
  background-image: url(../../assets/userinfo/agree_bg.jpg);
  background-size: 100% 100%;
  position: absolute;
  top: 50px;
  left: 10px;
  border-radius: 6px;
}
.alert_bg3 {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(82, 82, 82, 0.36);
}
.bind {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(82, 82, 82, 0.36);
  z-index: 8;

  .close_btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 10px;
    background-image: url(../../assets/common/close4.svg);
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 2;
  }
  .close_btn:hover {
    opacity: 0.8;
    cursor: pointer;
  }

  .bind_wrap {
    width: 370px;
    height: 290px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -185px;
    margin-top: -145px;
    overflow: hidden;
    background-color: rgba(252, 252, 252, 1);
    border-radius: 4px;

    .bind_title {
      color: rgba(26, 26, 26, 1);
      font-size: 17px;
      font-weight: bolder;
      text-align: center;
      margin-top: 25px;
    }
    .bind_icon {
      height: 116px;
      width: 116px;
      margin: 0 auto;
      margin-top: 20px;
      background-image: url(../../assets/common/nas_icon.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bind_name {
      font-size: 14px;
      font-weight: bolder;
      color: rgba(31, 93, 227, 1);
      text-align: center;
      margin-top: 8px;
    }

    .bind_btns {
      text-align: center;
      margin-top: 20px;
      .bind_cancel_btn {
        display: inline-block;
        vertical-align: top;
        background-color: rgba(230, 230, 230, 1);
        width: 130px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        font-weight: bolder;
        margin-right: 15px;
      }
      .bind_sure_btn {
        display: inline-block;
        vertical-align: top;
        width: 130px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        color: rgba(255, 255, 255, 1);
        background-color: rgba(31, 93, 227, 1);
        font-size: 14px;
        font-weight: bolder;
      }

      .bind_cancel_btn:hover,
      .bind_sure_btn:hover {
        opacity: 0.9;
        cursor: pointer;
      }
    }
  }

  .success_wrap {
    width: 300px;
    height: 320px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -160px;
    overflow: hidden;
    background-color: rgba(252, 252, 252, 1);
    border-radius: 4px;
    .success_title {
      font-size: 17px;
      font-weight: bolder;
      color: rgba(31, 93, 227, 1);
      text-align: center;
      margin-top: 25px;
    }

    .success_icon {
      width: 230px;
      height: 130px;
      background-image: url(../../assets/common/bind/success_icon.png);
      background-size: 100% 100%;
      margin: 0 auto;
      margin-top: 30px;
    }

    .success_name {
      font-size: 14px;
      font-weight: bolder;
      color: rgba(102, 102, 102, 1);
      text-align: center;
      margin-top: 8px;
    }

    .bind_btns {
      text-align: center;
      margin-top: 20px;
      .bind_cancel_btn {
        display: inline-block;
        vertical-align: top;
        background-color: rgba(230, 230, 230, 1);
        width: 130px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        font-weight: bolder;
        margin-right: 15px;
      }
      .bind_sure_btn {
        display: inline-block;
        vertical-align: top;
        width: 100px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        color: rgba(255, 255, 255, 1);
        background-color: rgba(31, 93, 227, 1);
        font-size: 14px;
        font-weight: bolder;
      }

      .bind_cancel_btn:hover,
      .bind_sure_btn:hover {
        opacity: 0.9;
        cursor: pointer;
      }
    }
  }

  .failed_wrap {
    width: 300px;
    height: 320px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -160px;
    overflow: hidden;
    background-color: rgba(252, 252, 252, 1);
    border-radius: 4px;

    .failed_title {
      color: rgba(26, 26, 26, 1);
      font-size: 17px;
      font-weight: bolder;
      text-align: center;
      margin-top: 30px;
      height: 22px;
      line-height: 22px;
    }

    .failed_tips {
      color: rgba(227, 68, 33, 1);
      text-align: center;
      font-size: 12px;
      margin-top: 3px;
      height: 20px;
      line-height: 20px;
    }

    .text2 {
      position: relative;
      margin: 5px auto;
      margin-top: -5px;
      width: 190px;
      height: 41px;
      line-height: 41px;
      font-size: 14px;
      text-align: left;
      padding-left: 20px;
      background-color: rgba(31, 93, 227, 0.04);
      border-radius: 20px;
    }

    .text2::after {
      content: "";
      position: absolute;
      right: 18px;
      top: 10px;
      width: 20px;
      height: 20px;
      background-image: url("../../assets/userinfo/a2.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }

    .failed_help {
      // background-color: RGBA(243, 246, 251, 1);
      color: rgba(102, 102, 102, 1);
      width: 160px;
      padding: 10px 25px;
      font-size: 12px;
      margin: 0 auto;
      margin-top: 5px;
      text-align: center;
    }

    .failed_qrcode {
      width: 126px;
      height: 126px;
      margin: 0 auto;
      background-color: #cccccc;
      // background-image: url(../../assets/common/kf_qrcode.jpg);
      background-image: url(../../assets/remote/bindf2.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .qq_qun {
      text-align: center;
      margin-top: 0px;
    }

    .failed_sure_btn {
      background-color: rgba(31, 93, 227, 1);
      width: 100px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #ffffff;
      font-size: 14px;
      font-weight: bolder;
      border-radius: 20px;
      margin: 0 auto;
      margin-top: 15px;
    }
    .failed_sure_btn:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }
}
</style>